import http from './http-common';

class FabricCategoryService {
  getAll() {
    return http.get('/fabricCategory');
  }
  getFabricCategoryForList() {
    return http.get('fabricCategory/getFabricCategoryForList');
  }
}

export default new FabricCategoryService();
